import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import Home from "./components/Home";
import layout from "./Layout";
import DashboardHeader from "./components/Dashboard";
import Agency from "./components/Dashboard/Common/Agency";
import Branch from "./components/Dashboard/Common/Branch";
import HealthProductMaster from "./components/Dashboard/HealthProduct/HealthProductMaster"
import Layout from "./Layout";
import OtherProduct from "./components/Dashboard/GeneralInsurance/OtherProduct";
import MotorProduct from "./components/Dashboard/GeneralInsurance/MotorProduct";
import MotorAddOns from "./components/Dashboard/GeneralInsurance/MotorAddOns";
import AddAgency from "./components/Dashboard/Common/Agency/AddAgency";
import AddBranch from "./components/Dashboard/Common/Branch/AddBranch";
import AddOtherProduct from "./components/Dashboard/GeneralInsurance/OtherProduct/AddOtherProduct";
import AddMotorProduct from "./components/Dashboard/GeneralInsurance/MotorProduct/AddMotorProduct";
import AddMotorAddOns from "./components/Dashboard/GeneralInsurance/MotorAddOns/AddMototAddons";
import HealthProduct from "./components/Dashboard/HealthProduct";
import AddVehicleMaster from "./components/Dashboard/Common/VehicleMaster/AddVehicleMaster";
import VehicleMaster from "./components/Dashboard/Common/VehicleMaster";
import CustomerMasterList from "./components/Dashboard/Common/CustomerMaster";
// import AddCustomerMaster from "./components/Dashboard/CustomerMaster/AddCustomerMaster";
import AddCustomerMaster from "./components/Dashboard/Common/CustomerMaster/AddCustomerMaster";
import GroupMaster from "./components/Dashboard/Common/Groupmaster";
import AddGroupMaster from "./components/Dashboard/Common/Groupmaster/AddGroupMaster"
import VehicleMakeMaster from "./components/Dashboard/GeneralInsurance/VehicleMakeMaster";
import AddVehicleMakeMaster from "./components/Dashboard/GeneralInsurance/VehicleMakeMaster/AddVehicleMakeMaster";
import VehicleModelMaster from "./components/Dashboard/GeneralInsurance/VehicleModel";
import AddVehicleModelMaster from "./components/Dashboard/GeneralInsurance/VehicleModel/AddVehicleModel";
import RoleMaster from "./components/Dashboard/Admin/Roles";
import AddRole from "./components/Dashboard/Admin/Roles/AddRole";
import RolePrivilege from "./components/Dashboard/Admin/RolePrivilege";
import AddRolePrivilege from "./components/Dashboard/Admin/RolePrivilege/AddRolePrivilege";
import AddLifeProductMaster from "./components/Dashboard/LifeInsurance/LifeProductMaster/AddLifeProductMaster";
import LifeProductMasterList from "./components/Dashboard/LifeInsurance/LifeProductMaster";
import HealthInsuranceQuotation from "./components/Dashboard/GeneralInsurance/HealthInsuranceQuotation";
import AddHealthInsuranceQuotation from "./components/Dashboard/GeneralInsurance/HealthInsuranceQuotation/AddHealthInsuranceQuotation";
import OtherInsuranceQuotation from "./components/Dashboard/GeneralInsurance/OtherInsuranceQuotation";
import AddOtherInsuranceQuotation from "./components/Dashboard/GeneralInsurance/OtherInsuranceQuotation/AddOtherInsuranceQuotation";
import AddNewProfile from "./components/Dashboard/MyProfile/AddNewProfile";
import EmployeeMasterList from "./components/Dashboard/Admin/EmployeeMaster";
import AddEmployee from "./components/Dashboard/Admin/EmployeeMaster/AddEmployee";
import ConsolidatedRenewalList from './components/Dashboard/GeneralInsurance/consolidatedRenewal/ConsolidatedRenewalList'
import Contact from "./components/Home/components/Contact";
import ActiveInactiveCustomerList from "./components/Dashboard/Common/activeInactiveCustomerList/ActiveInactiveCustomerList";
import PolicyRegister from "./components/Dashboard/GeneralInsurance/PolicyRegister/PolicyRegister";
import AddAreaMaster from "./components/Dashboard/Common/AreaMaster/AddAreaMaster";
import AreaMaster from "./components/Dashboard/Common/AreaMaster";
import AddThemeMaster from "./components/Dashboard/Admin/ThemeMaster/AddThemeMaster";
import LifePolicyList from "./components/Dashboard/LifeInsurance/LifePolicyEntry";
import AddLifePolicyEntry from "./components/Dashboard/LifeInsurance/LifePolicyEntry/AddLifePolicyEntry";
import AddPremiumDepositEntry from "./components/Dashboard/LifeInsurance/PremiumDepositEntry/AddPremiumDepositEntry";
import PremiumDepositEntryList from "./components/Dashboard/LifeInsurance/PremiumDepositEntry";
import BatchFupUpdate from "./components/Dashboard/LifeInsurance/FUP/BatchFupUpdate";
import LifePolicyRegister from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/LifePolicyRegister/LifePolicyRegister";
import PolicyReport from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/LifePolicyRegister/PolicyReport";
import LifeInsuranceEntry from "./components/Dashboard/LifeInsurance/LifePolicyEntry/AddLifePolicyEntry";
import LifeInsuranceImportPolicyData from "./components/Dashboard/LifeInsurance/LifeInsuranceImportPolicyData/LifeInsuranceImportPolicyData"
import PremiumDueReport from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/PremiumDueReport/PremiumDueReport";
import PremiumOutstandingReport from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/PremiumOutstandingReport/PremiumOutstandingReport";
import LapsedPoliciesReport from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/LapsedPoliciesReport/LapsedPoliciesReport";
import LapsedPoliciesReportGenerate from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/LapsedPoliciesReport/LapsedPoliciesReportGenerate";
import PremiumDueReportGenerate from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/PremiumDueReport/PremiumDueReportGenerate";
import PremiumOutstandingReportGenerate from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/PremiumOutstandingReport/PremiumOutstandingReportGenerate";
import CurrentStatusReport from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/CurrentStatusReport/CurrentStatusReport";
import CurrentStatusReportPreview from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/CurrentStatusReport/CurrentStatusReportPreview";
import MaturityPoliciesReport from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/MaturityPoliciesReport/MaturityPoliciesReport";
import MaturityPoliciesReportPreview from "./components/Dashboard/LifeInsurance/AllReportsLifeInsurance/MaturityPoliciesReport/MaturityPoliciesReportPreview";
function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <Routes>
        <Route element={<Layout />}>

          <Route path="/dashboard" element={<LifeProductMasterList />} />
          <Route path="health-product/add" element={<HealthProductMaster />} />
          <Route path="agency" element={<Agency />} />
          <Route path="agency/add" element={<AddAgency />} />
          <Route path="/agency/edit/:id" element={<AddAgency />} />
          <Route path="branch" element={<Branch />} />
          <Route path="branch/add" element={<AddBranch />} />
          <Route path="/branch/edit/:id" element={<AddBranch />} />
          <Route path="other-product" element={<OtherProduct />} />
          <Route path="other-product/add" element={<AddOtherProduct />} />
          <Route path="motor-product" element={<MotorProduct />} />
          <Route path="motor-product/add" element={<AddMotorProduct />} />
          <Route path="motor-addons" element={<MotorAddOns />} />
          <Route path="motor-addons/add" element={<AddMotorAddOns />} />
          <Route path="vehicle" element={<VehicleMaster />} />
          <Route path="vehicle-master/add" element={<AddVehicleMaster />} />
          <Route path="customer" element={<CustomerMasterList />} />
          <Route path="customer-master/add" element={<AddCustomerMaster />} />
          <Route path="customer-master/edit/:id" element={<AddCustomerMaster />} />

          <Route path="group-master/add" element={<AddGroupMaster />} />
          {/* <Route path="/group-master/edit/:id" element={<AddGroupMaster />} /> */}
          <Route path="/group-master/edit/:id" element={<AddGroupMaster isUpdateMode={true} />} />

          <Route path="group" element={<GroupMaster />} />
          <Route path="vehicle-make" element={<VehicleMakeMaster />} />
          <Route path="vehicle-make/add" element={<AddVehicleMakeMaster />} />
          <Route path="vehicle-model" element={<VehicleModelMaster />} />
          <Route path="vehicle-model/add" element={<AddVehicleModelMaster />} />
          <Route path="roles" element={<RoleMaster />} />
          <Route path="role/add" element={<AddRole />} />
          <Route path="role-privilege" element={<RolePrivilege />} />
          <Route path="role-privilege/add" element={<AddRolePrivilege />} />
          <Route path="life-product" element={<LifeProductMasterList />} />
          <Route path="life-product/add" element={<AddLifeProductMaster />} />
          <Route path="/life-product/edit/:id" element={<AddLifeProductMaster />} />


          <Route path="life-policy-entry" element={<LifePolicyList />} />
          <Route path="life-policy-entry/add" element={<AddLifePolicyEntry />} />
          <Route path="/life-policy-entry/edit/:id" element={<AddLifePolicyEntry isUpdateMode={true} />} />

          <Route path="health-insurance" element={<HealthInsuranceQuotation />} />
          <Route path="health-insurance/add" element={<AddHealthInsuranceQuotation />} />

          <Route path="other-insurance" element={<OtherInsuranceQuotation />} />
          <Route path="other-insurance/add" element={<AddOtherInsuranceQuotation />} />

          <Route path="my-profile" element={<AddNewProfile />} />

          <Route path="employee-master/add" element={<AddEmployee />} />
          <Route path="/employee-master" element={<EmployeeMasterList />} />

          <Route path="consolidated-renewal-list" element={<ConsolidatedRenewalList />} />
          <Route path="active-inactive-customer" element={<ActiveInactiveCustomerList />} />
          <Route path="policy-register" element={<PolicyRegister />} />

          <Route path="/premium-deposit-entry" element={<AddPremiumDepositEntry />} />
          <Route path="/premium-deposit-entry-list" element={<PremiumDepositEntryList />} />
          <Route path="/premium-deposit-entry/edit/:id" element={<AddPremiumDepositEntry />} />

          <Route path="area-master/add" element={<AddAreaMaster />} />
          <Route path="area-master-list" element={<AreaMaster />} />
          <Route path="/area-master/edit/:id" element={<AddAreaMaster />} />
          <Route path="/life-policy-register" element={<LifePolicyRegister />} />

          <Route path="theme-master" element={<AddThemeMaster />} />
          <Route path="/fup-update" element={<BatchFupUpdate />} />
          <Route path="/policy-report" element={<PolicyReport />} />
          <Route path="/premium-due-report" element={<PremiumDueReport />} />
          <Route path="/premium-due-report-preview" element={<PremiumDueReportGenerate />} />
          <Route path="/lapsed-policies-report-preview" element={<LapsedPoliciesReportGenerate />} />
          <Route path="/premium-outstanding-report-preview" element={<PremiumOutstandingReportGenerate />} />
          <Route path="/premium-outstanding-report" element={<PremiumOutstandingReport />} />
          <Route path="/lapsed-policy-report" element={<LapsedPoliciesReport />} />

          <Route path="/import-policy-report" element={<LifeInsuranceImportPolicyData />} />
          <Route path="/current-status-report" element={<CurrentStatusReport />} />
          <Route path="/current-status-report-preview" element={<CurrentStatusReportPreview />} />

           <Route path="/maturity-policies-report" element={<MaturityPoliciesReport />} />
          <Route path="/maturity-policies-report-preview" element={<MaturityPoliciesReportPreview />} />



        </Route>
        <Route path="contact" element={<Contact />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </>
  );
}

export default App;
